import { Link } from "@simplybusiness/mobius";

export function PhoneNumber(number: string) {
  return <Link href={`tel:${number}`}>{number}</Link>;
}
